<template lang="pug">
b-modal#modal-area-pop-up-script(title='貼り付け用タグを取得')
  .callout.callout-info
    p
      | 以下のタグを、ポップアップを表示したいWebページbody内の、スクロールした際に出現させたい位置に設置してください。
      br/
      | タグ設置方法は
      a(class="text-primary", href="https://docs.google.com/presentation/d/1KpAYhUqPNecSY-hVYmDiLVE6omAjmDcQspgZnOYY988/edit?usp=sharing", target="_blank") こちら
      | をご参照ください。
  .row
    textarea.form-control(rows=5,v-if="$store.state.area_pop_up.specific_position_flag")
      | <div id="area_pop_up_{{$store.state.area_pop_up.token}}"></div>
      | <script type="text/javascript" charset="utf-8" src="{{$store.state.area_pop_up.url}}"></script>
    textarea.form-control(rows=5,v-else)
      | <script type="text/javascript" charset="utf-8" src="{{$store.state.area_pop_up.url}}"></script>
</template>

<script>
import Vue from 'vue'

export default {
  methods: {
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
